import {
  DialogContent,
  DialogTitle,
  TextField,
  DialogActions,
  Button,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import PopUp from "../popUpInterface";
import { styles } from "./styles";
import Loading from "../loading";
/*----styles----*/
class EmbedCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      html: null,
    };
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  open = (html) => {
    if (html) this.setState({ html: html });
    this.PopUp.handleDialogOpen();
  };
  close = () => {
    this.PopUp.handleDialogClose();
  };
  update = () => {
    const { html } = this.state;
    this.props.updateHTML(html);
    this.close();
  };
  handleChange = (e) => {
    let target = e.target;
    this.setState({ html: target.value });
  };
  render() {
    const { html } = this.state;
    const { classes, t } = this.props;
    return (
      <Fragment>
        <PopUp
          onRef={(dialog) => (this.PopUp = dialog)}
          openDialogs={this.state.openDialogs}
          aria-labelledby="customized-dialog-title"
          flagOpen={false}
          handleDialogClose={this.close}
        >
          <Loading onRef={(id) => (this.loading = id)} />
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            style={{ padding: 0 }}
          >
            <Typography variant="h2" className={classes.title}>
              {t("embed_code")}
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.DialogContent}>
            <TextField
              variant="outlined"
              multiline
              row={3}
              value={html}
              fullWidth
              onChange={this.handleChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.close} color="primary">
              {t("post_cancel")}
            </Button>
            <Button onClick={this.update} color="primary">
              {t("post_update")}
            </Button>
          </DialogActions>
        </PopUp>
      </Fragment>
    );
  }
}
const mapState = (state) => ({
  serviceBranchState: state.serviceBranch,
});
const mapDispatch = (dispatch) => ({
  employeeDispatch: dispatch.employees,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: true })(EmbedCode))
);
